import React from 'react';
import { useSelector } from 'react-redux';
import Header from "../components/Header";
import Sidebar from "../components/Sidebar";
import GameGrid from "../components/GameGrid";
import '../styles/HomePage.css';

const HomePage = () => {
  const { categoriesLoading, categoriesError } = useSelector(state => state.categories);
  const { gamesLoading, gamesError } = useSelector(state => state.games);

  // 显示加载状态
  if (categoriesLoading || gamesLoading) {
    return (
      <div className="loading-state">
        {categoriesLoading && <div>Loading categories...</div>}
        {gamesLoading && <div>Loading games...</div>}
      </div>
    );
  }
  
  // 显示错误状态
  if (categoriesError || gamesError) {
    return (
      <div className="error-state">
        {categoriesError && <div>Categories Error: {categoriesError}</div>}
        {gamesError && <div>Games Error: {gamesError}</div>}
      </div>
    );
  }

  return (
    <div className="app-container">
      <Header />
      <div className="content-wrapper">
        <Sidebar />
        <main className="main-content">
          <div className="game-container">
            <GameGrid />
          </div>
        </main>
      </div>
    </div>
  );
};

export default HomePage;
